import http from '@/util/http.js'

// 仓库列表
export function getViewWarehouseList(params) {
  return http({ url: '/warehouse/getViewWarehouseList', method: 'get', params })
}

// 修改仓库
export function saveWarehouse(data) {
  return http.post('/warehouse/saveWarehouse', data)
}

// 删除仓库
export function deleteWarehouse(data) {
  return http.post('/warehouse/deleteWarehouse', data)
}

//初始化
export function initWarehouse(data) {
  return http({ url: '/warehouse/initWarehouse', method: 'post', data: data })
}

//记录仓库分享链接时效
export function recordShareLink(data) {
  return http({ url: '/warehouse/recordShareLink', method: 'post', data: data })
}

//获取仓库链接的文件地址
export function getShareWarehouseInfo(params) {
  return http({
    url: '/share/getWarehouseInfo',
    headers: {
      isToken: false
    },
    method: 'get',
    params
  })
}

// 仓库统计数据
export function statistical(data) {
  return http.get('/warehouse/statistical/' + data)
}

// 获取库存出入记录
export function getStockRecords(params) {
  return http({ url: '/product/stock/getStockRecords', method: 'get', params })
}

// 获取用户库存统计面板
export function statistic(params) {
  return http({ url: '/product/stock/statistic', method: 'get', params })
}

// 绑定仓库
export function bindWarehouse(params) {
  return http({ url: '/education/bindWarehouse', method: 'get', params })
}

// 仿真案例仓库
export function getWarehouseList(params) {
  return http({ url: '/warehouse/getWarehouseList', method: 'get', params })
}

// 查询仓库信息
export function getWarehouseInfo(params) {
  return http({ url: '/warehouse/getInfo', method: 'get', params })
}

export function getDemoWarehouseList(){
  return http({ url: '/warehouse/getDemoWarehouseList', method: 'get' })
}